module.exports = __webpack_public_path__ + "img/calender.83a3284a.jpg";